import { useQuery } from '@tanstack/react-query';

import { getQueryKey } from '@/api/utils/getQueryKey';
import { handleApiCall } from '@/api/utils/handleApiCall';
import { useAuth } from '@/context/AuthProvider';

export interface VendorDetails {
  id: string;
  name: string;
  address: string;
  distance: string;
  distance_meters?: number | null;
  distance_formatted?: string;
  distance_miles?: number;
  services: string;
  website?: string | null;
  phone: string;
  phone_type: string;
  email?: string | null;
  reason_for_recommendation: string;
  match_score: number;
  emergency_service: boolean;
  created_at: string;
  updated_at: string;
}

export interface VendorSearchHistory {
  id: string;
  search_query: string;
  processed_query?: string;
  address: string;
  vendor_count: number;
  created_at: string;
  search_metadata?: Record<string, unknown>;
  vendors: VendorDetails[];
}

export interface SearchHistoryResponse {
  success: boolean;
  data: VendorSearchHistory[];
}

const METHOD = 'GET';
const ENDPOINT = 'vendor/search/history';
export const QUERY_KEY = () => getQueryKey(METHOD, ENDPOINT);

export const useGetSearchHistory = (enabled = true) => {
  const { session } = useAuth();

  return useQuery({
    enabled: enabled && !!session?.access_token,
    queryKey: QUERY_KEY(),
    queryFn: async () => {
      const response = await handleApiCall<SearchHistoryResponse>(
        session,
        METHOD,
        ENDPOINT
      );
      return response.data || [];
    },
  });
};